










import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import detailModule from '@/model/store/modules/detail-module';
import contentsModule from '@/model/store/modules/contents-module';
import contentsService from '@/model/services/contents-service';
import {GCICategoryInfoRes, GCIContentsListRes, GCICategoryListRes, GCIContentsInfoRes} from '@/model/dto/res/contents/get-category-list-res';
import _ from 'lodash';

@Component({
  components: {
  }
})
export default class Breadcrumb extends Vue {
  /** Data **/
  private isOffset: boolean = false;

  /** Computed **/
  get categoryInfo() {
    return appModule.categoryInfo;
  }

  get contents() {
    return detailModule.contents;
  }

  get breadCrumbs() {
    return detailModule.breadcrumbs;
  }

  get innerYOffset() {
    return this.isOffset ? 0 : contentsModule.innerYOffset;
  }

  /** Watch **/
  @Watch('contents')
  private onChangeContents(): void {
    const token = this.$route.query.token ?? userModule.apiToken;
    this.$router.push({path: `${this.$route.path}` }).catch(err => err);
  }

  /** Watchers **/
  @Watch('$route')
  private async onChangeRoute(to: {path: string, name: string}, from: {path: string, name: string}): Promise<void> {
    if (to.name === 'account-viewer' || to.name === 'edit-viewer') {
      this.isOffset = true;
    } else {
      this.isOffset = false;
    }
  }

  /** Methods **/

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    if (this.$route.name === 'account-viewer' || this.$route.name === 'edit-viewer') {
      this.isOffset = true;
    } else {
      this.isOffset = false;
    }
  }

}
